import React from 'react';
import TermsTemplate from './TermsTemplate';

export default function ServiceTerms() {
  const content = `
    <h2>제1조 (목적)</h2>
    <p>본 약관은 클로젯(이하 "회사")이 제공하는 패션 큐레이션 및 전자상거래 서비스(이하 "서비스")의 이용과 관련하여 회사와 이용자 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.</p>

    <h2>제2조 (용어의 정의)</h2>
    <ol>
      <li>"서비스"란 회사가 제공하는 패션 콘텐츠 추천, 상품 판매, 큐레이션 등의 모든 서비스를 의미합니다.</li>
      <li>"이용자"란 본 약관에 따라 회사가 제공하는 서비스를 이용하는 회원 및 비회원을 말합니다.</li>
      <li>"회원"이란 회사와 서비스 이용계약을 체결하고 회원 아이디(ID)를 부여받은 자를 말합니다.</li>
      <li>"릴스"란 회사가 제공하는 숏폼 패션 콘텐츠를 의미합니다.</li>
      <li>"키워드 선호도"란 회원의 패션 취향을 파악하기 위한 키워드 기반 추천 알고리즘을 의미합니다.</li>
    </ol>

    <h2>제3조 (약관의 효력 및 변경)</h2>
    <ol>
      <li>본 약관은 서비스 화면에 게시하거나 기타의 방법으로 이용자에게 공지함으로써 효력이 발생합니다.</li>
      <li>회사는 필요한 경우 관련 법령을 위배하지 않는 범위에서 본 약관을 변경할 수 있습니다.</li>
      <li>회사가 약관을 변경할 경우 적용일자 및 변경사유를 명시하여 현행약관과 함께 서비스 초기화면에 그 적용일자 7일 전부터 적용일자 전일까지 공지합니다.</li>
    </ol>

    <h2>제4조 (회원가입)</h2>
    <ol>
      <li>이용자는 회사가 정한 가입 양식에 따라 회원정보를 기입한 후 본 약관에 동의한다는 의사표시를 함으로써 회원가입을 신청합니다.</li>
      <li>회사는 제1항과 같이 회원으로 가입할 것을 신청한 이용자 중 다음 각 호에 해당하지 않는 한 회원으로 등록합니다.
        <ul>
          <li>가. 등록 내용에 허위, 기재누락, 오기가 있는 경우</li>
          <li>나. 만 14세 미만인 경우</li>
          <li>다. 기타 회원으로 등록하는 것이 회사의 기술상 현저히 지장이 있다고 판단되는 경우</li>
        </ul>
      </li>
    </ol>

    <h2>제5조 (서비스의 제공)</h2>
    <p>회사는 다음과 같은 서비스를 제공합니다.</p>
    <ul>
      <li>가. 패션 콘텐츠(릴스) 큐레이션 및 추천 서비스</li>
      <li>나. 키워드 기반 맞춤형 콘텐츠 제공 서비스</li>
      <li>다. 패션 상품 판매 중개 서비스</li>
      <li>라. 상품 검색 및 필터링 서비스</li>
      <li>마. 장바구니 및 위시리스트 서비스</li>
      <li>바. 주문, 결제, 배송 관련 서비스</li>
      <li>사. 상품 리뷰 및 평가 서비스</li>
      <li>아. 사용자 피드백 수집 서비스</li>
      <li>자. 카카오톡 등 SNS 공유 서비스</li>
      <li>차. 기타 회사가 추가 개발하거나 제휴계약 등을 통해 제공하는 서비스</li>
    </ul>

    <h2>제6조 (서비스의 중단)</h2>
    <ol>
      <li>회사는 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다.</li>
      <li>회사는 제1항에 의한 서비스 중단의 경우 사전 또는 사후에 이를 공지합니다.</li>
    </ol>

    <h2>제7조 (회원의 의무)</h2>
    <p>회원은 다음 행위를 하여서는 안 됩니다.</p>
    <ul>
      <li>가. 신청 또는 변경 시 허위내용의 등록</li>
      <li>나. 타인의 정보 도용</li>
      <li>다. 회사가 게시한 정보의 변경</li>
      <li>라. 회사가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시</li>
      <li>마. 회사와 기타 제3자의 저작권 등 지적재산권에 대한 침해</li>
      <li>바. 회사 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위</li>
      <li>사. 외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 서비스에 공개 또는 게시하는 행위</li>
    </ul>

    <h2>제8조 (저작권의 귀속 및 이용제한)</h2>
    <ol>
      <li>회사가 작성한 저작물에 대한 저작권 기타 지적재산권은 회사에 귀속합니다.</li>
      <li>이용자는 서비스를 이용함으로써 얻은 정보 중 회사에게 지적재산권이 귀속된 정보를 회사의 사전 승낙 없이 복제, 송신, 출판, 배포, 방송 기타 방법에 의하여 영리목적으로 이용하거나 제3자에게 이용하게 하여서는 안 됩니다.</li>
    </ol>

    <h2>제9조 (개인정보보호)</h2>
    <p>회사는 이용자의 개인정보를 보호하기 위하여 개인정보처리방침을 수립하고 이를 준수합니다.</p>

    <h2>제10조 (회원탈퇴 및 자격 상실)</h2>
    <ol>
      <li>회원은 언제든지 회사에 탈퇴를 요청할 수 있으며, 회사는 즉시 회원탈퇴를 처리합니다.</li>
      <li>회원이 다음 각 호의 사유에 해당하는 경우, 회사는 회원자격을 제한 및 정지시킬 수 있습니다.
        <ul>
          <li>가. 가입 신청 시에 허위 내용을 등록한 경우</li>
          <li>나. 다른 사람의 서비스 이용을 방해하거나 그 정보를 도용하는 등 전자상거래 질서를 위협하는 경우</li>
          <li>다. 서비스를 이용하여 법령 또는 본 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우</li>
        </ul>
      </li>
    </ol>

    <h2>제11조 (면책조항)</h2>
    <ol>
      <li>회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다.</li>
      <li>회사는 회원의 귀책사유로 인한 서비스 이용의 장애에 대하여 책임을 지지 않습니다.</li>
      <li>회사는 회원이 서비스를 이용하여 기대하는 수익을 상실한 것에 대하여 책임을 지지 않으며, 그 밖에 서비스를 통하여 얻은 자료로 인한 손해에 관하여 책임을 지지 않습니다.</li>
    </ol>

    <h2>제12조 (분쟁해결)</h2>
    <ol>
      <li>회사는 이용자가 제기하는 정당한 의견이나 불만을 반영하고 그 피해를 보상처리하기 위하여 피해보상처리기구를 설치·운영합니다.</li>
      <li>회사와 이용자 간에 발생한 전자상거래 분쟁과 관련하여 이용자의 피해구제신청이 있는 경우에는 공정거래위원회 또는 시·도지사가 의뢰하는 분쟁조정기관의 조정에 따를 수 있습니다.</li>
    </ol>

    <h2>제13조 (재판권 및 준거법)</h2>
    <ol>
      <li>회사와 이용자 간에 발생한 전자상거래 분쟁에 관한 소송은 제소 당시의 이용자의 주소에 의하고, 주소가 없는 경우에는 거소를 관할하는 지방법원의 전속관할로 합니다.</li>
      <li>회사와 이용자 간에 제기된 전자상거래 소송에는 대한민국법을 적용합니다.</li>
    </ol>

    <p><strong>부칙</strong><br>
    본 약관은 2025년 11월 1일부터 시행됩니다.</p>

    <p><strong>회사 정보</strong><br>
    상호: 클로젯<br>
    대표: 김재원<br>
    이메일: admin@clozet.my</p>
  `;

  return (
    <TermsTemplate
      title="서비스 이용약관"
      content={content}
      lastUpdated="2025년 11월 1일"
    />
  );
}
